import { Pipe, PipeTransform, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { DynamicTranslationService } from '@gs-2.0/core';

@Pipe({
  name: 'translateLang',
  standalone: true,
  pure: false
})
export class TranslateLangPipe implements PipeTransform, OnDestroy {
  private lastKey: string = '';
  private lastParams: string = '';
  private lastValue: string = '';
  private subscription?: Subscription;

  constructor(
    private translationService: DynamicTranslationService,
    private cdr: ChangeDetectorRef
  ) {}

  transform(key: string, params?: { [key: string]: any }): string {
    if (!key || key === '') {
      return key;
    }

    // Check if we have the translation service
    if (!this.translationService) {
      console.error('DynamicTranslationService not available in TranslateLangPipe');
      return key;
    }

    // Create a cache key that includes params
    const paramsKey = params ? JSON.stringify(params) : '';

    // If key and params haven't changed, return cached value
    if (key === this.lastKey && paramsKey === this.lastParams && this.lastValue) {
      return this.lastValue;
    }

    // Clean up previous subscription
    if (this.subscription) {
      this.subscription.unsubscribe();
    }

    // Subscribe to translation changes
    this.subscription = this.translationService.translations$.subscribe(
      translations => {
        this.lastKey = key;
        this.lastParams = paramsKey;
        this.lastValue = this.translationService.instant(key, params);
        this.cdr.markForCheck();
      }
    );

    // Get instant translation
    const instantTranslation = this.translationService.instant(key, params);

    // Update cache
    this.lastKey = key;
    this.lastParams = paramsKey;
    this.lastValue = instantTranslation;

    return instantTranslation;
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}

